import httpClient from "./httpClient";

const CommandMessageService = {
  async findAll(limit) {
    return await httpClient.get("/command-message", { params: limit ? { limit } : {} });
  },

  async unreadCount() {
    return await httpClient.get("/command-message/unread-count");
  },

  async markRead(id) {
    return await httpClient.post(`/command-message/${id}/read`);
  },

  async markAllRead() {
    return await httpClient.post("/command-message/mark-all-read");
  },
};

export default CommandMessageService;
